import { AllowedAny, AnyObject } from '../types/common';
import { Logger } from './LoggerService';

export abstract class BaseService {
  abstract serviceName: string;

  protected log(message: string, data?: AnyObject) {
    Logger.info(message, { context: this.serviceName, ...data });
  }

  protected logWarn(message: string, data?: AnyObject) {
    Logger.warn(message, { context: this.serviceName, ...data });
  }

  protected logError(message: string, error?: unknown, data?: AnyObject) {
    Logger.error(message, error, { context: this.serviceName, ...data });
  }

  protected logDuration(message: string, startTime: number, data?: AnyObject) {
    Logger.duration(message, startTime, { context: this.serviceName, ...data });
  }
}

export type LoggedDecoratorOptions = {
  start: string;
  finish: string;
  error: string;
};

export function logged(options: LoggedDecoratorOptions) {
  return function (_target: BaseService, _methodName: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: AllowedAny[]) {
      try {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- It's okay, we check target in the wrapper
        // @ts-expect-error
        this.log(options.start);

        const result = originalMethod.apply(this, args);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- It's okay, we check target in the wrapper
        // @ts-expect-error
        this.log(options.finish);

        return result;
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- It's okay, we check target in the wrapper
        // @ts-expect-error
        this.logError(options.error, error);
        throw error;
      }
    };
  };
}
